import React, { useEffect } from 'react'
import SiteFooter from '../components/SiteFooter'
import SiteMark from '../components/SiteMark'
import { reference } from '../data/reference'
import { headers } from '../data/record'
import PageHeader from '../components/PageHeader'

// Deliberately plain. This is a working list, not a showcase: no menu item,
// linked once from the footer. Every URL for the film, the festivals, the
// screenings, the press and the partners, in one place.

const Reference = () => {
  useEffect(() => {
    document.title = 'Links | The Girl and Her Piano'
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className='App page-standard page-reference'>
      <SiteMark />
      <PageHeader {...headers.reference} title='Links' />

      <main>
        {reference.sections.map((section) => (
          <section className='reference-section' data-tone='light' key={section.title}>
            <div className='content-container'>
              <h2>{section.title}</h2>
              {section.note && <p className='reference-note'>{section.note}</p>}
              {/* The label is the link. Raw URLs are ugly and nobody reads
                  them; anything without a link is simply left out. */}
              <ul className='reference-list'>
                {section.items.map((item) => (
                  <li className='reference-item' key={item.url}>
                    <a href={item.url} target='_blank' rel='noopener noreferrer'>{item.label}</a>
                    {item.flag && <span className='reference-flag'>{item.flag}</span>}
                  </li>
                ))}
              </ul>
            </div>
          </section>
        ))}
      </main>

      <SiteFooter />
    </div>
  )
}

export default Reference
